import type { FigmaIconProps } from './types';

export const IconFigmaCheck = ({ size = 28, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.3022 5.96891C22.8718 5.3994 23.7949 5.3994 24.3644 5.96891C24.9339 6.53843 24.9339 7.46157 24.3644 8.03109L11.5311 20.8644C10.9616 21.4339 10.0384 21.4339 9.46891 20.8644L3.63558 15.0311C3.06606 14.4616 3.06606 13.5384 3.63558 12.9689C4.20509 12.3994 5.12824 12.3994 5.69775 12.9689L10.5 17.7712L22.3022 5.96891Z"
      fill={color}
    />
  </svg>
);
